import React from 'react';
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

interface FormProviderProps {
    children: React.ReactNode;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Can be any type of data
    methods: UseFormReturn<any>;
    onSubmit?: VoidFunction;
}

export default function FormProvider({
    children,
    onSubmit,
    methods,
}: FormProviderProps) {
    return (
        <Form {...methods}>
            <form onSubmit={onSubmit}>{children}</form>
        </Form>
    );
}
